import React from 'react';
import StepIndicator from './StepIndicator';
import { REASONS } from './constants';
import { Icon } from '../../../elements/icon';
import { useTranslation } from 'react-i18next';

function ReasonScreen({ selectedReason, onSelect, onNext, onClose }) {
  const { t } = useTranslation();
  const canNext = !!selectedReason;

  return (
    <>
      <StepIndicator step={1} onBack={() => {}} showBack={false} onClose={onClose} />

      <div className="t-mb-4">
        <h2 className="t-text-[26px] t-font-serif t-text-slate-900 t-leading-tight t-mb-2">
          {t('CancelFlow_Reason_Title_Line1')}
          <br />
          <em className="!t-text-secondary">{t('CancelFlow_Reason_Title_Line2')}</em>
        </h2>
        <p className="t-text-sm t-text-slate-600 t-m-0">{t('CancelFlow_Reason_Subtitle')}</p>
      </div>

      <div className="t-flex t-flex-col t-gap-1 t-mb-4">
        {REASONS.map((r) => {
          const isActive = selectedReason === r.id;
          return (
            <button
              key={r.id}
              type="button"
              onClick={() => onSelect(r.id)}
              className={`t-flex t-items-center t-gap-3 t-px-4 t-py-3 t-rounded-xl t-border t-transition
                ${
                  isActive
                    ? 't-border-teal-default t-bg-teal-bg'
                    : 't-border-slate-200 hover:t-border-teal-default hover:t-bg-teal-bg'
                }`}
            >
              <span
                className={`t-w-[18px] t-h-[18px] t-rounded-full t-border-2 t-flex t-items-center t-justify-center t-transition ${
                  isActive ? 't-border-secondary' : 't-border-slate-300'
                }`}
              >
                {isActive && <span className="t-w-[10px] t-h-[10px] t-rounded-full t-bg-secondary" />}
              </span>
              <span className="t-text-base" aria-hidden="true">
                {r.emoji}
              </span>
              <span
                className={`t-text-sm t-text-slate-800 t-text-left ${
                  isActive ? 't-font-medium' : 't-font-normal'
                }`}
              >
                {t(r.labelKey || `CancelFlow_Reason_${r.id}`, { defaultValue: r.label })}
              </span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={!canNext}
        className="t-w-full t-inline-flex t-items-center t-justify-center t-rounded-xl t-px-4 t-py-2 t-bg-secondary t-text-white t-font-semibold t-text-sm t-gap-2 t-disabled:t-opacity-50 t-disabled:t-cursor-not-allowed hover:t-shadow-[0_4px_12px_rgba(26,107,90,0.28)]"
      >
        <span>{t('CancelFlow_Reason_Next')}</span>
        <span aria-hidden="true">
          <Icon name="chevronRight" size={16} color="#fff" className="!t-mt-[6px]" />
        </span>
      </button>

      <button
        type="button"
        onClick={onClose}
        className="t-block t-w-full t-text-center t-text-xs t-text-slate-400 t-pt-2"
      >
        {t('CancelFlow_Reason_NeverMind')}
      </button>
    </>
  );
}

export default ReasonScreen;
